import { FeatureAppLoader } from '@feature-hub/react';
import React from 'react';
import { FeatureServicesContext } from '../../use-feature-services';
import { FeatureappServiceV1 } from '@volkswagen-onehub/featureapp-service';
import { Spinner } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const RedSpinner = styled(Spinner)`
  & .ForegroundPath-sc-uacxr {
    stroke: #c90010 !important;
  }
`;

export const QuizFormLoader = ({ onClose, errorCount }: { onClose: () => void; errorCount: string }) => {
  const featureServices = React.useContext(FeatureServicesContext);

  const featureAppService = featureServices?.['featureapp-service'] as FeatureappServiceV1;

  const [showOneForm, setShowOneForm] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const featureAppRef = React.useRef<any>(null);
  const formContainerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!showOneForm) {
      setShowOneForm(true);
    }
  }, [showOneForm]);

  React.useEffect(() => {
    if (!showOneForm || !formContainerRef.current) return;

    const observer = new MutationObserver(() => {
      const formElements = formContainerRef.current?.querySelectorAll('form, input, button');
      if (formElements && formElements.length > 0) {
        clearTimeout(timeout);
        setTimeout(() => setIsLoading(false), 500);
        observer.disconnect();
      }
    });

    observer.observe(formContainerRef.current, {
      childList: true,
      subtree: true,
    });

    const timeout = setTimeout(() => {
      setIsLoading(false);
      observer.disconnect();
    }, 20000);

    return () => {
      observer.disconnect();
      clearTimeout(timeout);
    };
  }, [showOneForm]);

  React.useEffect(() => {
    const featureApp = featureAppService?.featureAppConfigurations['es-oneform-lead-embedded'];
    featureAppRef.current = featureApp;
  }, [showOneForm, featureAppService]);

  const renderOneForm = () => (
    <div ref={formContainerRef}>
      <FeatureAppLoader
        {...featureAppRef.current}
        featureAppId={`${featureAppRef.current.name}:oneform`}
        done={() => {
          setShowOneForm(false);
          onClose();
        }}
        beforeCreate={(env) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const faContentService = env.featureServices['fa-content-service'] as any;
          if (faContentService) {
            faContentService.content = {
              featureApp: 'es-gti-50',
              dpsFields: [
                {
                  field: 'headers[FORM_WEB_SECTION]',
                  value: 'Golf GTI 50 Aniversario',
                },
                {
                  field: 'fields[VEH_INTEREST_ID]',
                  value: '30602',
                },
                {
                  field: 'fields[VEH_INTEREST_MODEL]',
                  value: 'Golf',
                },
                {
                  field: 'fields[VEH_INTEREST_SALESGROUP]',
                  value: 'Golf GTI',
                },
                {
                  field: 'fields[VEH_INTEREST_SALESGROUP_ID]',
                  value: '35272',
                },
                {
                  field: 'fields[VEH_INTEREST_TRIM_LINE]',
                  value: 'GTI',
                },
                {
                  field: 'fields[VEH_INTEREST_DETAILS]',
                  value: 'Edición 50 Aniversario',
                },
                {
                  field: 'fields[VEH_INTEREST_FUEL]',
                  value: 'Combustion',
                },
                {
                  field: 'fields[VEH_INTEREST_NEW_OR_USED]',
                  value: 'New Car',
                },
                {
                  field: 'fields[SURVEY_ANSWER_01]',
                  value: errorCount,
                },
              ],
            };
          }
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const apiKeyProvider = env.featureServices['api-key-provider'] as any;
          if (apiKeyProvider) {
            apiKeyProvider.apiKey = featureAppRef.current.apiKey;
          }
        }}
      />
    </div>
  );

  return (
    <>
      {isLoading && (
        <LoadingContainer>
          <RedSpinner variant={'x-large'} />
        </LoadingContainer>
      )}
      {showOneForm && featureAppRef.current && renderOneForm()}
    </>
  );
};
